export const MenuList = [
    //Dashboard
    {
        title: 'Dashboard',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="flaticon-dashboard-1" />,
        to: 'dashboard',	
        policies: ["POL0002"]
    },
    {
        title: 'Management',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="flaticon-381-briefcase" />,
        content: [
            {
                title: 'User',
                to: 'users',	
                policies: ["POL0001"]				
            },           
            {
                title: 'Roles',
                to: 'roles',	
                policies: ["POL0001"]				
            }, 
            {
                title: 'Policies',
                to: 'policies',
                policies: ["POL0001"]					
            },  
            {
                title: 'Property Type',
                to: 'property-type',
                policies: ["POL0001"]					
            }, 
            {
                title: 'Listing Type',
                to: 'listing-type',
                policies: ["POL0001"]					
            },  
            {
                title: 'Ownership Type',
                to: 'ownership-type',
                policies: ["POL0001"]					
            }, 
            {
                title: 'Furnishing Status',
                to: 'furnishing-status',
                policies: ["POL0001"]					
            },  
            {
                title: 'Facing Direction',
                to: 'facing-direction',
                policies: ["POL0001"]					
            }, 
            {
                title: 'Availability Status',
                to: 'availability-status',
                policies: ["POL0001"]					
            },
            {
                title: 'Amenity',
                to: 'amenity',
                policies: ["POL0001"]					
            }, 
            {
                title: 'Feature',
                to: 'features',
                policies: ["POL0001"]					
            },
            {
                title: 'Price Unit',
                to: 'price-unit',
                policies: ["POL0001"]					
            },
            {
                title: 'Pricing',
                to: 'pricing',
                policies: ["POL0001"]					
            },
            {
                title: 'Banks',
                to: 'banks',
                policies: ["POL0001"]					
            },
        ],
    },
    {
        title:"Property",
        classsChange:'mm-collapse',
        iconStyle : < i className="flaticon-381-layer-1" />,
        content : [
            {
                title:'Add Property',
                to:'add-property',
                policies: ["POL0003"]
            },
            {
                title:'Active Properties',
                to:'property-list',
                policies: ["POL0003"]
            },
            {
                title:'Pending Properties',
                to:'pending-property-list',
                policies: ["POL0003"]
            },
            {
                title:'Sold Properties',
                to:'sold-property-list',
                policies: ["POL0003"]
            },
            {
                title:'Featured Properties',
                to:'featured-property-list',
                policies: ["POL0003"]
            },
            // {
            //     title:'Verified Properties',
            //     to:'verified-property-list',
            //     policies: ["POL0003"]
            // },
            {
                title:'Reported Properties',
                to:'reported-property-list',
                policies: ["POL0003"]
            },
            {
                title:'Blocked Properties',
                to:'blocked-property-list',
                policies: ["POL0003"]
            },
            {
                title:'Rejected Properties',
                to:'rejected-property-list',
                policies: ["POL0003"]
            }
        ]
    },
    {
        title: 'Reports',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="fas fa-file-alt" />,
        content: [
            {
                title: 'Property Report',
                to: 'property-report',	
                policies: ["POL0001"]				
            },           
            {
                title: 'Payment Report',
                to: 'payment-report',	
                policies: ["POL0001"]				
            }, 
            {
                title: 'Customer Report',
                to: 'customer-report',	
                policies: ["POL0001"]				
            }, 
            {
                title: 'Property Verification Report',
                to: 'property-verification-report',	
                policies: ["POL0001"]				
            },
            {
                title: 'Bank Verification Report',
                to: 'bank-verification-report',	
                policies: ["POL0001"]				
            },
        ],
    },
    {
        title: 'Customers',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="flaticon-381-user-7" />,
        to: 'customer-list',	
        policies: ["POL0001"]
    },
    // {
    //     title: 'Subscriptions',	
    //     classsChange: 'mm-collapse',		
    //     iconStyle: <i className="fas fa-sync-alt" />,
    //     content: [
    //         {
    //             title: 'Subscriptions',
    //             to: 'subscription-list',	
    //             policies: ["POL0001"]				
    //         },           
              
    //     ],
    // },
    {
        title: 'Help & Support',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-question-circle" />,
        to: 'support',
        policies: ["POL0001"]
    },
    {
        title: 'Payments',	
        classsChange: 'mm-collapse',		
        iconStyle: <i className="fas fa-credit-card" />,
        to: 'payment-list',	
        policies: ["POL0001"]
    },
    {
        title:"Pending List",
        classsChange:'mm-collapse',
        iconStyle : < i className="flaticon-381-layer-1" />,
        to:'pending-verification-list',
        policies: ["POL0008"]
    },
    {
        title:"In Verification List",
        classsChange:'mm-collapse',
        iconStyle : < i className="flaticon-381-layer-1" style={{color:'#a8db1dff'}}/>,
        to:'verification-list',
        policies: ["POL0008"]
    },
    {
        title:"Completed List",
        classsChange:'mm-collapse',
        iconStyle : < i className="flaticon-381-layer-1" style={{color:'#12cb78ff'}}/>,
        to:'completed-list',
        policies: ["POL0008"]
    },
    {
        title:"Pending List",
        classsChange:'mm-collapse',
        iconStyle : < i className="flaticon-381-layer-1"/>,
        to:'pending-bank-verification-list',
        policies: ["POL0010"]
    },
    {
        title:"Verification List",
        classsChange:'mm-collapse',
        iconStyle : < i className="flaticon-381-layer-1" style={{color:'#a8db1dff'}}/>,
        to:'bank-verification-list',
        policies: ["POL0010"]
    },
    {
        title:"Completed List",
        classsChange:'mm-collapse',
        iconStyle : < i className="flaticon-381-layer-1" style={{color:'#12cb78ff'}}/>,
        to:'bank-completed-list',
        policies: ["POL0010"]
    }
]